module.exports = __webpack_public_path__ + "static/media/11.2fa7f85d.mp3";